import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M78.9405 44.2853C78.9405 44.2853 60.2605 34.0353 56.2105 29.3053C51.7105 24.0453 51.9105 1.40527 51.9105 1.40527H39.4805C39.4805 1.40527 39.7905 24.1553 35.1805 29.3053C30.2905 34.7653 12.2305 43.6254 12.2305 43.6254C18.4205 58.2054 36.1605 67.9053 45.7005 67.9053C55.2405 67.9053 72.7405 58.8653 78.9405 44.2853Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M87.24 58.5154C85.38 47.1554 82.03 44.0353 77.36 41.8053L45.58 59.6553L13.8 41.8053C9.13 44.0353 5.5 47.4754 3.92 58.5154C2.29 69.8754 2 71.5853 2 71.5853H89.15C89.16 71.5953 88.91 68.7254 87.24 58.5154Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="45.5816"
          y1="40.5964"
          x2="45.5816"
          y2="14.5999"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
